import React from 'react';
import {Translate} from 'react-redux-i18n';

const NotFound = () => (
  <div>
    <h3><Translate value="404.title"/></h3>
    <p><Translate value="404.desc"/></p>
  </div>
);

export default NotFound;
